
import React, { useState } from 'react';
// @ts-ignore
import XomeLogo from '../../assets/xome-logo-2.png';
import {  getLandingPageUrl } from '../../utils/config';

export default function NotInvitedUser() {
    return (
        <div className="flex flex-col items-center max-w-[90%]  sm:max-w-[50%] xl:max-w-[40%] mx-auto mt-40 lg:mt-24 bg-[#F8F8F8] py-5 min-h-[60vh] sm:min-h-[50vh] xl:min-h-[70vh] px-4 sm:px-10 xl:px-20 border-2">
            <img
                className="w-32 h-auto sm:w-40 mt-2 object-contain"
                src={XomeLogo}
                alt="Logo"
            />
            <div className="flex w-full max-w-full border-t-2  mt-3" />
            <div className=" flex flex-col gap-y-7 mt-10 text-[#3B3B3B] ">
                <p className="text-justify w-[100%] sm:w-auto font-light sm:font-normal text-sm sm:text-base leading-5">
                    The email address you used to sign up is not enabled for Xbid. Please proceed as below
                </p>
                <p>1. If you have received an email invitation to join Xbid, ensure you use the same email address to <a href="/signup" className='text-[#FF5C39]' >Sign up</a>.</p>
                <p>2. If you do not have an invitation but wish to join Xbid, share your interest on this <a href={getLandingPageUrl()} className='text-[#FF5C39]'>Xbid website</a> , after which Xome Concierge team will contact you. </p>


            </div>

        </div>
    );
}
